import React from "react";
import moment from "moment";

class ReportModalCM extends React.Component {
  render() {
    const {data} = this.props;
    let hoy = new Date();
    var Hora = hoy.getHours();
    var Min = hoy.getMinutes();
    var Fecha = hoy.toLocaleDateString();

    let subTotal = 0;
    let total = 0;
    let IGV = 0;
    let precios = 0;
    !!data && data.map(item => {
        subTotal = item.DocTotal - item.VatSum;
        precios += parseFloat(item.Price*item.Quantity);
        subTotal = subTotal === 0 ? precios : subTotal;
        total = item.DocTotal;
        IGV = item.VatSum;
    });

    if(data.length === 0){
    return (
        <div></div>
    );
    }
    return (
      <div>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width: '50px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{width: '50px',textAlign:'center', paddingTop:'70px'}}>
              <img style={{width: '100%', height:'auto'}} src="https://rintisa.com.pe/images/logo.svg" />
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>        
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{textAlign:'center'}}>
              <h3 style={{fontWeight:'bold'}}>RUC: {data[0].CardCode.substring(1)}</h3>    
            </th>
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>{Fecha}-{Hora}:{Min}hs</h3>
            </th>
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>{data[0].CardName}</h3>
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{textAlign:'center'}}>
              <h3 style={{fontWeight:'bold'}}>NRO.SOLICITUD: {data[0].DocEntry}</h3>    
            </th>     
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>EMISIÓN : {moment(data[0].DocDate.substring(0,10)).utc().format('DD-MM-YYYY') }</h3>
            </th>
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>F.DESPACHO : {moment(data[0].DocDueDate.substring(0,10)).utc().format('DD-MM-YYYY') }</h3>
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%', borderCollapse: 'collapse'}}>
          <tr style={{backgroundColor:'#0078C0',paddingTop: '12px', paddingBottom: '12px', textAlign: 'left', color: 'white'}}>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{textAlign:'center'}}>#</th>
            <th style={{textAlign:'center'}}>EAN</th>
            <th style={{textAlign:'left'}}>Producto</th>
            <th style={{textAlign:'center'}}>Cantidad</th>
            <th style={{textAlign:'center'}}>Precio Final</th>
            <th style={{textAlign:'center'}}>Total sin IGV</th>
            <th style={{textAlign:'center'}}>Precio Vigente (con descuento) SAP</th>
            <th style={{textAlign:'center'}}>Total sin IGV SAP</th>
            <th style={{textAlign:'center'}}>Dif. de P. Unit</th>
            <th style={{textAlign:'center'}}>Dif. Total</th>
            <th style={{visibility:'hidden'}}>a</th>
          </tr>
          {!!data && data.map((item, index) => {
            let totalsinIgv = (item.U_SYP_CCCOMENT)*(item.Quantity);
            return (
                  <tr>
                    <th style={{visibility:'hidden'}}>a</th>
                    <th style={{textAlign:'center'}}>{index+1}</th>
                    <th style={{textAlign:'center'}}>{item.ItemCode}</th>
                    <th style={{textAlign:'left', fontSize:12}}>{item.ItemName}</th>                       
                    <th style={{textAlign:'center'}}>{parseInt(item.Quantity)}</th>
                    <th style={{textAlign:'right'}}>{item.Currency+' '+parseFloat(item.U_SYP_CCCOMENT).toFixed(2)}</th>
                    <th style={{textAlign:'right'}}>{item.Currency+' '+parseFloat(totalsinIgv).toFixed(2)}</th>
                    <th style={{textAlign:'right'}}>{item.Currency+' '+parseFloat(item.Price).toFixed(2)}</th>
                    <th style={{textAlign:'right'}}>{item.Currency+' '+parseFloat(item.LineTotal).toFixed(2)}</th>
                    <th style={{textAlign:'right'}}>{parseFloat(item.Price - item.U_SYP_CCCOMENT).toFixed(2)}</th>
                    <th style={{textAlign:'right'}}>{parseFloat(item.LineTotal-totalsinIgv).toFixed(2)}</th>
                    <th style={{visibility:'hidden'}}>a</th>
                  </tr> 
                );
            })
          }    
        </table>    
        <br></br>        
      </div>
    );
  }
}

export default ReportModalCM;